import { Div, Collection, CollectionPrinter } from "@tblabs/truffle";
import { Human } from "../../../../Models/Human";
import { HumanEntryEdit } from "./HumanEntryEdit";
import { OptionsBox } from "./OptionsBox";


export class HumanEdit extends Div
{
    constructor(people: Collection<Human>)
    {
        super();

        this.Append(
            new CollectionPrinter(people, x => new HumanEntryEdit(x, people)).Class("panels-container"),
            new OptionsBox({
                "➕ Osoba": () => people.Add(new Human({}))
            })
        );
    }
}
